<template>
    <div class="root" v-loading="loading">
        <div style="height: 1px;"></div>
        <div class="theme-showcase">


            <div class="contentDiv" ref="scrollContainer" style="background-color: #f1f1f1;">
                <div v-for="(item, index) in list" :key="item.id" class="itemdiv">
                    <div style="display: flex; font-size: 16px; color: #666;"><img
                            src="https://jinyuan.daxuxian.com/images/icon/date.png"
                            style="width: 24px; height: 24px; margin-right: 5px;" /> {{ item.CreateTime }}</div>
                    <div style="font-size:16px; margin: 5px 0; color: #666;">来源：微信</div>
                    <div style="font-size: 16px; color: #666;">类型：{{ item.Category }}</div>
                    <div style="margin: 5px 0; font-size: 16px; color: #666;">所选门店：{{ item.ShopName }}</div>
                    <div style="font-size: 18px; white-space: pre-wrap;">{{ item.ContentTxt }}</div>
                    <div style="padding: 2px 0px; margin: 0 -5px;">
                        <div v-for="item2 in item.ImgUrls" :key="item2" :class="{ 'inlineblockdiv': item.inlineblock }"
                            @click="triggleImg(index)">
                            <div style="margin: 5px; border: 1px #f1f1f1 solid;">
                                <img :src="item2" style="width: 100%;" />
                            </div>
                        </div>
                    </div>

                    <div style="margin: 8px 0; height: 1px; width: 100%; border-top: 1px #ddd dashed;"></div>

                    <div v-if="item.HandleTime">
                        <div style="display: flex; font-size: 16px; color: #1195db;"><img
                                src="https://jinyuan.daxuxian.com/images/icon/chulijieguo.png"
                                style="width: 24px; height: 24px; margin-right: 5px;" />处理结果</div>
                        <div style="font-size:16px; margin: 5px 0; color: #666;">回复时间：{{ item.HandleTime }}</div>
                        <div style="font-size:16px; margin: 5px 0; color: #666;">处理人：{{ item.HandleUserName }}</div>
                        <div style="font-size: 18px; white-space: pre-wrap;">{{ item.HandleTxt }}</div>
                    </div>


                    <img v-if="item.HandleTime" src="https://jinyuan.daxuxian.com/images/icon/yichuli.png"
                        style="width: 50px; position:absolute; right: 20px; top:15px;" />
                    <img v-else src="https://jinyuan.daxuxian.com/images/icon/weichuli.png"
                        style="width: 50px; position:absolute; right: 20px; top:15px;" />
                </div>
            </div>

            <div v-if="wxopenid=='' && list.length==0" style="background-color: #fff; margin-top: 100px;">
                <div style="text-align: center; background-color: #fff;">
                    <el-button type="primary" plain size="small" @click="refresh">刷新</el-button>
                </div>
            </div>

            <div style=" background:#f1f1f1; text-align: center; padding: 10px 0 20px 0; " v-if="list.length > 10">
                ~没有更多数据了~
            </div>
            <div style="height: 60px; margin-top: 0px;">
            </div>

            <div style="position: fixed; bottom: 0; left: 0; width: 100vw; border-top: 1px #c8c8c8 solid;">
                <div
                    style=" max-width: 520px; margin: auto; background-color: #f7f6fb; display: flex; padding: 6px 0; color: gray; font-size: 14px; line-height: 18px;">
                    <div style="flex: 1;text-align: center;" @click="tosug">
                        <div><img style="width:26px;" src="https://jinyuan.daxuxian.com/images/icon/biji1.png" /></div>
                        <div style="text-align: center;">提建议</div>
                    </div>
                    <div style="flex: 1;text-align: center;" @click="tosuglist">
                        <div><img style="width:26px;" src="https://jinyuan.daxuxian.com/images/icon/gongshi1.png" />
                        </div>
                        <div style="text-align: center;">意见建议公示台</div>
                    </div>
                    <div style="flex: 1; text-align: center;" @click="tomysug">
                        <div><img style="width:26px;" src="https://jinyuan.daxuxian.com/images/icon/wode2.png" /></div>
                        <div style="text-align: center; color: #1aac19;">我的建议</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    name: 'mysug',
    data: function () {
        return {
            form: {},
            loading: false,
            list: [],
            showReBtn:false,
            wxopenid:''
        }
    },
    components: {

    },
    methods: {
        tosug() {
            this.$router.push('/');
        },
        tosuglist() {
            this.$router.push('/suglist');
        },
        tomysug() {
            this.$router.push('/mysug');
        },
        checkwx() {

            const userInfoStr = this.$route.query.userInfo;
            const wxtoken = this.$route.query.wxtoken;
            if (userInfoStr && userInfoStr.length > 0) {
                // localStorage.setItem("wxuserJson", userInfoStr);
                var userInfo = JSON.parse(userInfoStr);
                this.nickname2 = userInfoStr;
                try {

                    localStorage.setItem("wxopenid", userInfo['openid']);
                    localStorage.setItem("wxnickname", userInfo['nickname']);
                    localStorage.setItem("wxtoken", wxtoken);
                    this.wxtoken = wxtoken;
                    this.wxopenid = userInfo['openid'];
                } catch (err) {

                }
            } else {

            }

        },

        getwxuserinfo() {
            this.loading = true;
            axios.get('/api/weixin/GetAuthorizeUrl?st=suggestion')
                .then(this.getwxuserinfoSucc)
        },
        getwxuserinfoSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.success) {
                var url = res.authorizeUrl;
                window.location.href = url;
            } else {

            }
        },

        triggleImg(index) {
            console.log(index);
            this.list[index].inlineblock = !this.list[index].inlineblock;
        },

        loadData(page) {
            this.loading = true;
            axios.post('/api/Suggestion/SuggestionList',
                {
                    skip: (page - 1) * 10,
                    limit: 1000,
                    my: 1,
                    token: this.wxtoken,
                    openid: this.openid
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.list = res.list;
                this.total = res.total;
                if (res.list != null && res.list.length > 0) {
                    var item = res.list[0];
                } else {

                }
            } else {
                if (res && res.Code == 301) {
                    this.getwxuserinfo();
                }
            }
        },
        refresh(){
                    this.getwxuserinfo();
        }
    },
    mounted() {
        var errcode = this.$route.query.errcode;
        console.log(errcode);
        if (errcode == 'reject') {
            return;
        } else {
            this.checkwx();
        }

        var openid = localStorage.getItem('wxopenid');
        if (openid && openid != null && openid != undefined) {
            this.openid = openid;
            this.wxopenid=openid;
        } else {
            this.getwxuserinfo();
        }

        var wxnickname = localStorage.getItem("wxnickname");
        if (wxnickname) {
            this.nickname = wxnickname;
        }
        var wxtoken = localStorage.getItem("wxtoken");
        if (wxtoken) {
            this.wxtoken = wxtoken;
        }

        this.loadData(1);
    },
    beforeDestroy() {

    }
}
</script>
<style scoped>
.contentDiv>div {
    font-size: 18px;
    line-height: 24px;
}

.contentDiv {
    padding: 1px;
    
    max-width: 520px;
    margin: auto;
}

.inlineblockdiv {
    display: inline-block;
    width: 33.33%;
}

.itemdiv {
    position: relative;
    background: #fff;
    margin: 12px 10px;
    padding: 10px;
    border-end-end-radius: 10px;
    border-end-start-radius: 10px;
    border-top: 3px #1195db solid;
}

.mytd {
    border-bottom: 1px #ccc solid;
    border-right: 1px #ccc solid;
    padding: 10px;
    margin: 0;
    box-sizing: border-box;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.root>>>.topmenuitem:nth-child(10) {
    color: #fff;
    background-color: #080808;
}

.root>>>.el-dialog {
    width: 80% !important;
}



.rootdiv>>>.topmenuitem:nth-child(8) {
    color: #fff;
    background-color: #080808;
}

.avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader>>>.el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader>>>.el-upload--picture-card {
    width: 20vw !important;
    height: 20vw !important;
    line-height: 20vw;
}

.avatar-uploader>>>.el-upload-list__item {
    width: 20vw;
    height: 20vw;
}

.avatar-uploader>>>.el-upload {}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 20vw !important;
    height: 20vw !important;
    line-height: 20vw;
    text-align: center;
}

.avatar {
    width: 20vw;
    display: block;
}

.hide {
    .el-upload--picture-card {
        display: none !important;
    }
}

.root>>>.el-dialog__body {
    padding: 1px !important;
}

.root>>>.el-dialog__header {
    padding: 16px 10px 10px 10px;
    border-bottom: 1px #f1f1f1 solid;
}

.divshopitem {
    border-bottom: 1px #f1f1f1 solid;
    padding: 12px 15px;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/suggestions/mysug.vue